'use strict';

var hasSymbols = require('has-symbols/shams');

/** @type {import('.')} */
module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/has-tostringtag/shams.js
 ** module id = 439
 ** module chunks = 0
 **/